module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0089.jpg?v=c9dde16f";